import * as $ from 'jquery';
import * as _ from 'underscore';

import { IGlob } from '../../../pdc-platform/src/ts/Glob';
import * as Utilities from '../../../_common/platform/ts/Utilities';
import * as DateTimeFunctions from '../../../_common/platform/ts/DateTimeFunctions';
import * as AttrQueryValuesFormat from '../../../_common/platform/ts/AttrQueryValuesFormat';
import { IAttribute } from '../../../_common/platform/tsx/filtering/Interfaces';
import { themeFields } from './themes/themeFields';
import { isUserDefinedInterval } from '../../../_common/platform/tsx/IntervalsSelect';
import { ATTRIBUTE_TYPES, FORMATS, TIME_PART_FORMATS } from '../../../_common/platform/ts/ConfigurationConstants';
import { isD3chart } from './chartConstants';
import { IValuesCollection } from '../../../_common/platform/ts/appTheme';
import { IAttrQueryMulti } from './components/Interfaces';

function getValueFromTheme(theme: IValuesCollection, themeField: string) {
    let result;

    if (theme != null && theme[themeFields[themeField]] != null) {
        result = theme[themeFields[themeField]];
    }

    return result;
}

export class ChartPropsManager {
    //LL: my flag, Leo wants = false
    public static ApplyFormattedTimeParts: boolean = false;

    public static get_chartTypeMain_Value(values) {
        if (values == null) {
            return null;
        }
        let chartTypeMain_Value = values['chartTypeMain'];
        //LL: is true:
        //if (ChartWidget.chartTypeMainDefinedByFirstBlock === true) {
        let attrQueryMulti = values['attrQueryMulti'];

        if (attrQueryMulti != null && attrQueryMulti.attrQueries != null && attrQueryMulti.attrQueries.length > 0) {
            chartTypeMain_Value = attrQueryMulti.attrQueries[0].parameters.chartType;
        }
        //}
        return chartTypeMain_Value;
    }

    public static isMultiValueAxis(values, theme: IValuesCollection) {
        let multiAxis = true;
        let chartAxisArray = [];

        if (theme != null) {
            let resV = getValueFromTheme(theme, 'axis_ChartAxisField_Arr');

            if (resV != null) {
                chartAxisArray = resV;
            }
        }

        let N = 0;

        $.each(chartAxisArray, (key: any) => {
            //LL: these keys are outdated functionality, not used anywhere. Was used when in Params, not in Themes
            if (key !== 'isSet' && key !== 'removeAxis') {
                N++;
            }
        });

        multiAxis = N > 0;

        return multiAxis;
    }

    public static getChartAxisArray(values, theme: IValuesCollection) {
        let _ChartAxisArray = [];
        if (theme != null) {
            let resV = getValueFromTheme(theme, 'axis_ChartAxisField_Arr');
            if (resV != null) {
                _ChartAxisArray = resV;
            }
        }
        return _ChartAxisArray;
    }

    public static getIsAxisReduced(values) {
        let chartTypeMain_Value = ChartPropsManager.get_chartTypeMain_Value(values);
        return isD3chart(chartTypeMain_Value);
    }

    public static setValueByTheme_static(themeObj, _themeField) {
        let V;
        if (themeObj != null && themeObj[themeFields[_themeField]] != null) {
            V = themeObj[themeFields[_themeField]];
        }
        return V;
    }

    public static is_rotated(values, theme: IValuesCollection) {
        let _rotateXY = false;
        let resV = getValueFromTheme(theme, 'axis_rotateXY');

        if (resV != null) {
            _rotateXY = resV;
        }

        return _rotateXY;
    }

    public static get_ChartTypes_Multi(attrQueryMulti: IAttrQueryMulti) {
        if (attrQueryMulti == null) {
            return null;
        }

        if (
            attrQueryMulti.attrQueries == null ||
            attrQueryMulti.attrQueries.length === 0 ||
            attrQueryMulti.attrQueries[0].parameters.chartType == null
        ) {
            return null;
        }

        let result: string[] = [];

        for (let k = 0; k < attrQueryMulti.attrQueries.length; k++) {
            let par = attrQueryMulti.attrQueries[k].parameters;

            if (par.used === false) {
                continue;
            }
            //LL: Adjusted - stacked, fullstacked:
            if (par.chartTypeAdjusted != null) {
                result.push(par.chartTypeAdjusted);
            } else {
                result.push(par.chartType);
            }
        }

        return result;
    }

    public static processScatterWithDiscreteArgumentAxis(values, valueAQM, valueAxisX, theme: IValuesCollection) {
        //LL: values.chartAxisField_X is very empty if all is default

        let axisObj;
        if (valueAxisX == null) {
            axisObj = getValueFromTheme(theme, 'axis_ChartAxisField_X');
        } else {
            axisObj = valueAxisX;
        }

        if (axisObj == null) {
            return;
        }
        if (ChartPropsManager.isContinuous(axisObj.type)) {
            return;
        }

        let aqmObj;
        if (valueAQM == null) {
            aqmObj = values['attrQueryMulti'];
        } else {
            aqmObj = valueAQM;
        }

        let ChartTypes = ChartPropsManager.get_ChartTypes_Multi(aqmObj);
        let hasScatter = false;
        for (let i = 0; i < ChartTypes.length; i++) {
            if (ChartTypes[i] === 'scatter') {
                hasScatter = true;
                break;
            }
        }
        if (hasScatter) {
            Utilities.showNotification('warning', 'You have "Scatter" ChartType with discrete Argument axis.', true);
        }
    }

    public static getHiddenGroup_Pie(values) {
        // hidden if not Pie
        if (values == null) {
            return false;
        }
        let chartTypeMain_Value = ChartPropsManager.get_chartTypeMain_Value(values);
        return !(chartTypeMain_Value === 'pie' || chartTypeMain_Value === 'doughnut');
    }

    public static getHiddenGroup_XY(values) {
        // hidden if Pie
        if (values == null) {
            return false;
        }
        let chartTypeMain_Value = ChartPropsManager.get_chartTypeMain_Value(values);
        return chartTypeMain_Value === 'pie' || chartTypeMain_Value === 'doughnut';
    }

    public static getHiddenGroup_XY_withoutD3(values) {
        // hidden if not XY (Pie, D3)
        if (values == null) {
            return false;
        }
        let chartTypeMain_Value = ChartPropsManager.get_chartTypeMain_Value(values);
        return chartTypeMain_Value === 'pie' || chartTypeMain_Value === 'doughnut' || isD3chart(chartTypeMain_Value);
    }

    public static getHiddenGroup_not_D3(values) {
        // hidden if not D3
        if (values == null) {
            return false;
        }
        let chartTypeMain_Value = ChartPropsManager.get_chartTypeMain_Value(values);
        return !isD3chart(chartTypeMain_Value);
    }

    public static getHiddenGroup_for_D3(values) {
        // hidden if D3
        if (values == null) {
            return false;
        }
        let chartTypeMain_Value = ChartPropsManager.get_chartTypeMain_Value(values);

        return isD3chart(chartTypeMain_Value);
    }

    public static evalAuxAxisNames(_ChartAxisArray) {
        let a = [];
        $.each(_ChartAxisArray, function (key, obj) {
            //LL: these keys are outdated functionality, not used anywhere. Was used when in Params, not in Themes
            if (key !== 'isSet' && key !== 'removeAxis') {
                let nn = obj.name;
                if (nn != null) {
                    a.push($.trim(nn));
                }
            }
        });
        let va = a.join(';');
        return va;
    }

    //LL: used in Strips, ConstLines, Breaks  and similar ..._inThemes
    public static getAxisType(values, axisName: string, themeObj: IValuesCollection) {
        let axisObj;
        let valuesField;
        let themesField;

        if (axisName === 'arguments') {
            valuesField = 'chartAxisField_X';
            themesField = 'axis_ChartAxisField_X';
        } else if (axisName === 'values') {
            valuesField = 'chartAxisField_Y';
            themesField = 'axis_ChartAxisField_Y';
        }
        //LL: AuxAxis:
        else {
            valuesField = 'ChartAxisArrayField';
            themesField = 'axis_ChartAxisField_Arr';
        }

        let resV = getValueFromTheme(themeObj, themesField);

        if (resV != null) {
            if (axisName === 'arguments') {
                axisObj = resV;
            } else if (axisName === 'values') {
                axisObj = resV;
            }
            //LL: AuxAxis:
            else {
                axisObj = resV[axisName];
            }
        }

        if (axisObj == null) {
            return null;
        } else if (axisObj.type === 'default') {
            // "default" -> "automatic"
            return null;
        }
        return axisObj.type;
    }

    //LL: ========  Data Types =====================

    public static mixTimePartsToNumeric = true;

    public static isDateTimeType(dataType) {
        return DateTimeFunctions.isTypeOfAnyDate(dataType);
    }

    public static get_noGrouping(_attrQuery) {
        let noGroup = false;

        if (_attrQuery.length > 0) {
            let value = _attrQuery[0];
            if (value.aggregateGroup == null || value.aggregateGroup == 'none') {
                noGroup = true;
            }
        }

        return noGroup;
    }

    //LL: UserDefined Intervals always are of type "s". They can be for Dates and Numeric
    public static isUserDefinedInterval(intervals) {
        return isUserDefinedInterval(intervals); //LL: in IntervalsSelect
    }

    public static getDefaultAttributeType_Static(attribute: IAttribute | string, dataSourceID: number, glob: IGlob) {
        if (attribute == null || attribute === '') {
            return null;
        }

        if (glob.EntityModelsStore.modelsAreLoaded([dataSourceID])) {
            let attributeName: string;

            if (typeof attribute === 'string') {
                attributeName = attribute;
            } else {
                if (attribute.valueType === 'variable') {
                    if (attribute.options == null) {
                        attribute.options = {};
                    }

                    if (attribute.options.dataQuery == null) {
                        attribute.options.dataQuery = {};
                    }

                    attributeName = attribute.options.dataQuery.attribute;
                } else {
                    attributeName = attribute.attribute;
                }

                //EVG 11.02.20: What is the use to make it ''? Such "Attribute" has null Default Type, so it is well enough to return null instead of calling getDefaultAttributeType().
                if (attributeName == null) {
                    return null; //EVG 11.02.20: attributeName = '';
                }
            }

            return glob.EntityModelsStore.getDefaultAttributeType(attributeName, dataSourceID);
        } else {
            //EVG: When the Entity Model is not loaded one should be sure that this null makes it work correctly.
            return null;
        }
    }

    public static getTimePart_Date(intervals) {
        //LL: LEO: if both are set, then first TimeInterval, then TimePart is applied.
        //    So, for me it is TimePart formatting
        if (intervals != null) {
            if (intervals.timePart != null && intervals.timePart !== 'none') {
                return intervals.timePart;
            }
        }
        return null;
    }

    private static xL_Val = 'XL';
    private static xC_Val = 'XC';
    private static xP_Val = 'XP';
    private static stackP_Val = 'StackP';
    private static C2F_Val = 'C2F';
    private static T_Val = 'T';
    private static A_Val = 'A';

    private static y_Val = 'Y';
    private static ya_Val = 'Ya';
    private static yb_Val = 'Yb';
    private static y3_Val = 'Y3';
    private static x1_Val = 'X1';
    private static x1d_Val = 'X1d';
    private static x2_Val = 'X2';
    private static x4_Val = 'X4';
    private static x4a_Val = 'X4a';
    private static x4s_Val = 'X4s';
    private static x5_Val = 'X5';
    private static x3_Val = 'X3';
    private static zSize_Val = 'Z_Size';
    private static yOpen_Val = 'Y_Open';
    private static yClose_Val = 'Y_Close';
    private static yHigh_Val = 'Y_High';
    private static yLow_Val = 'Y_Low';
    private static yMin_Val = 'Y_Min';
    private static yMax_Val = 'Y_Max';
    //=============================================

    public static idsArgs = ['X1', 'X1d'];
    public static idsStacked = ['X3'];
    public static idsSBS = ['X2', 'X4', 'X5', 'X4a', 'X4s'];
    public static idsValues = ['Y', 'Ya', 'Yb', 'Y3', 'Y_Open', 'Y_Close', 'Y_High', 'Y_Low', 'Y_Min', 'Y_Max'];
    public static idsPointLabel = ['XP']; //LL:  xP_Val = "XP"
    public static idsArgLabel = ['XL']; //LL:   xL_Val = "XL"
    public static idsPointColor = ['XC'];
    public static idsC2F = ['C2F'];
    public static idsTooltip = ['T'];
    public static idsAttribute = ['A'];

    public static getType_extended(_attrQuery, dataSourceID: number, ids, glob: IGlob) {
        let noGroup = ChartPropsManager.get_noGrouping(_attrQuery);

        //LL:  _attrQuery is not WidgetDescriptor

        let dType = 's';
        let isDate = false; //LL: real Date, i.e. that can be converted to date
        let timePart;

        let fnd = false; //LL: may be for XC, XP, XL    Also for previous SBS, Stacked !

        //LL: arg is single in AQ !
        for (let i = 0; i < _attrQuery.length; i++) {
            let value = _attrQuery[i];
            if (_.contains(ids, value.axis)) {
                dType = value.attrType;

                if (dType === 'e') {
                    let defaultAttributeType = ChartPropsManager.getDefaultAttributeType_Static(
                        value.attribute,
                        dataSourceID,
                        glob
                    );

                    if (defaultAttributeType != null) {
                        dType = defaultAttributeType;
                    }
                }

                if (!noGroup) {
                    if (AttrQueryValuesFormat.isCountAggregate(value)) {
                        dType = 'i';
                    }
                }

                //LL: UserDefined Intervals always are of type "s"
                //   They can be for Dates and Numeric
                if (ChartPropsManager.isUserDefinedInterval(value.intervals)) {
                    dType = 's';
                }

                if (ChartPropsManager.isDateTimeType(dType)) {
                    timePart = ChartPropsManager.getTimePart_Date(value.intervals);
                    isDate = timePart == null;
                }

                fnd = true;
                break;
            }
        }

        if (fnd) {
            return { type: dType, isDate: isDate, timePart: timePart };
        } else {
            return null;
        }
    }

    public static combine_dataTypes(dataTypes) {
        let typeComb = 's';

        if (dataTypes.length === 0) {
            return null;
        }

        if (dataTypes.length > 0) {
            typeComb = dataTypes[0];
        }

        let diff = false;
        if (dataTypes.length > 1) {
            //LL: unite 'date' and 'datetime' as datetime
            //LL: unite 'i' and 'r' as 'r'
            for (let i = 1; i < dataTypes.length; i++) {
                if (typeComb != dataTypes[i]) {
                    let dtComb = ChartPropsManager.isDateTimeType(typeComb);
                    let dt = ChartPropsManager.isDateTimeType(dataTypes[i]);
                    if (dtComb && dt) {
                        // but different
                        typeComb = 'datetime';
                    } else {
                        if (typeComb === 'i' && dataTypes[i] === 'r') {
                            typeComb = 'r';
                        } else if (!(typeComb === 'r' && dataTypes[i] === 'i')) {
                            // do nothing in such (!) case
                            diff = true;
                            break;
                        }
                    }
                }
            }
        }
        if (diff) {
            typeComb = 's'; //LL: or some other special, ex 'diff' ?
        }
        return typeComb;
    }

    public static getType_Multi(attrQueryMulti: IAttrQueryMulti, ids, glob: IGlob) {
        if (attrQueryMulti == null) {
            return { type: 's', isDate: false, timePart: 'none' };
        }

        //LL:  attrQuery is not WidgetDescriptor
        //LL: ArgAxis are many, but can be omitted currently
        let dType = 's';
        let isDate; //LL: real Date, i.e. that can be converted to date
        let timePartMix;
        let dataTypes = [];

        for (let k = 0; k < attrQueryMulti.attrQueries.length; k++) {
            let AQ = attrQueryMulti.attrQueries[k];

            let query = AQ.dataDescriptor;
            let aT = ChartPropsManager.getType_extended(query, AQ.dataSourceID, ids, glob);
            //        return { type: type, isDate: isDate, timePart: timePart };
            //LL: may return null

            //LL: Axis with mixed types TimePart and Numeric must behave as pure Numeric, for example for Label Format
            //   example:
            //   isDate = false, timePart = month, type = datetime
            //   isDate = false, timePart = null, type = i  (may be r)
            //   result must be isDate = false, timePart = null or none, type = i

            if (aT != null) {
                if (isDate == null) {
                    isDate = aT.isDate;
                } else {
                    isDate = isDate && aT.isDate;
                }

                if (timePartMix == null) {
                    timePartMix = aT.timePart;
                    if (timePartMix == null) {
                        timePartMix = 'none';
                    }
                } else {
                    if (timePartMix !== aT.timePart) {
                        timePartMix = 'none';
                    }
                }

                if (ChartPropsManager.mixTimePartsToNumeric) {
                    if (aT.timePart != null) {
                        aT.type = 'i'; //"_tp";
                    }
                }

                dataTypes.push(aT.type);
            }
        }

        let t = ChartPropsManager.combine_dataTypes(dataTypes);

        if (t != null) {
            dType = t;
        }

        if (ChartPropsManager.mixTimePartsToNumeric) {
            if (timePartMix != null && timePartMix !== 'none' && dType === 'i') {
                //"_tp";
                dType = 'datetime';
            }
        }

        return { type: dType, isDate: isDate, timePart: timePartMix };
    }

    public static getDataType_withTimePart(values, ids, glob: IGlob) {
        if (values == null) {
            return {}; // or null
        }

        const typeExt = ChartPropsManager.getType_Multi(values['attrQueryMulti'], ids, glob);
        const timePart = typeExt.timePart;

        let dType = typeExt.type;

        if (ChartPropsManager.isDateTimeType(dType)) {
            let can = typeExt.isDate;

            if (typeExt.timePart != null && typeExt.timePart !== 'none') {
                dType = 'i';
            } else if (!can) {
                dType = 's';
            }
        }

        return { type: dType, timePart: timePart };
    }

    public static get_argumentAxis_DataType_withTimePart(values, glob: IGlob) {
        return ChartPropsManager.getDataType_withTimePart(values, ChartPropsManager.idsArgs, glob);
    }

    public static get_argumentType_Multi(attrQueryMulti: IAttrQueryMulti, glob: IGlob) {
        //LL:  attrQuery is not WidgetDescriptor
        return ChartPropsManager.getType_Multi(attrQueryMulti, ChartPropsManager.idsArgs, glob);
    }

    public static get_argumentAxis_DataType_extended(values, glob: IGlob) {
        if (values == null) {
            return {}; // or null
        }

        return ChartPropsManager.get_argumentType_Multi(values['attrQueryMulti'], glob);
    }

    public static get_argumentAxis_AxisType_listCur_Full(values, glob: IGlob, toDisplay?) {
        let defaultValue = 'default';
        if (toDisplay === true) {
            defaultValue = 'automatic'; //LL: by Leo
        }

        // { type: argType, isDate: isDate, timePart: timePart };
        let typeExt: any = ChartPropsManager.get_argumentAxis_DataType_extended(values, glob);
        let argType = typeExt.type;
        //   argType=datetime isDate=false timePart=week   or   argType=s isDate=false timePart=undefined

        switch (argType) {
            case 's':
            case 'b':
            case 'e':
                return [defaultValue, 'discrete'];
            case 'i':
            case 'r':
                return [defaultValue, 'discrete', 'continuous', 'logarithmic'];
            case 'datetime':
            case 'date':
            case 'time':
                let can = typeExt.isDate;
                if (can) {
                    return [defaultValue, 'discrete', 'continuous'];
                } else {
                    //LL: see WI 56111"Charts: TimeParts (Week) on Argument Axis, continuous is prohibited":
                    //    Mail 23.11.15  "BUG Week can not be put on a Linear scale":
                    //    See: http://aviation1.pdc.dk/nextjet/#tabs/0/workspaces/2030
                    //    A datepart is always a number, that could be put on a linear scale

                    //LL: when 'continuous' is set, DevExpress error on console:
                    //    E2002 - Axis type and data type are incompatible. See:
                    //    http://js.devexpress.com/error/15_2/E2002
                    //LL:  because here 'continuous' is set for 'string' values. (They are strings by format)

                    //LL: my flag, Leo wants = false
                    if (ChartPropsManager.ApplyFormattedTimeParts) {
                        //LL: old:
                        return [defaultValue, 'discrete'];
                    } else {
                        //  this is used
                        if (typeExt.timePart != null) {
                            return [defaultValue, 'discrete', 'continuous'];
                        } else {
                            return [defaultValue, 'discrete'];
                        }
                    }
                }
            default:
                return [defaultValue, 'discrete'];
        }
    }

    public static getModifiedValuesAndDisplay_argumentAxis_AxisType_Full(values, glob: IGlob) {
        let a = ChartPropsManager.get_argumentAxis_AxisType_listCur_Full(values, glob);
        let d = ChartPropsManager.get_argumentAxis_AxisType_listCur_Full(values, glob, true);

        return { values: a, display: d };
    }

    public static get_yType(_attrQuery, dataSourceID: number, glob: IGlob) {
        //LL: noGroup same for all elements
        let noGroup = ChartPropsManager.get_noGrouping(_attrQuery);

        let yType = 's';
        let isDate; //LL: real Date, i.e. that can be converted to date
        let timePartMix;
        let dataTypes = [];
        for (let i = 0; i < _attrQuery.length; i++) {
            let value = _attrQuery[i];
            if (
                value.axis === ChartPropsManager.y_Val ||
                value.axis === ChartPropsManager.ya_Val ||
                value.axis === ChartPropsManager.yb_Val ||
                value.axis === ChartPropsManager.yOpen_Val ||
                value.axis === ChartPropsManager.yClose_Val ||
                value.axis === ChartPropsManager.yLow_Val ||
                value.axis === ChartPropsManager.yHigh_Val ||
                value.axis === ChartPropsManager.yMin_Val ||
                value.axis === ChartPropsManager.yMax_Val
            ) {
                let at = value.attrType;
                if (at === 'e') {
                    let DefaultAttributeType = ChartPropsManager.getDefaultAttributeType_Static(
                        value.attribute,
                        dataSourceID,
                        glob
                    );
                    if (DefaultAttributeType != null) {
                        at = DefaultAttributeType;
                    }
                }

                if (!noGroup) {
                    if (AttrQueryValuesFormat.isCountAggregate(value)) {
                        at = 'i';
                    }
                }

                //LL: UserDefined Intervals always are of type "s"
                //   They can be for Dates and Numeric
                if (ChartPropsManager.isUserDefinedInterval(value.intervals)) {
                    at = 's';
                }

                if (ChartPropsManager.isDateTimeType(at)) {
                    let timePart = ChartPropsManager.getTimePart_Date(value.intervals);
                    let canDate = timePart == null;

                    if (timePartMix == null) {
                        timePartMix = timePart;
                    } else if (timePartMix !== timePart) {
                        timePartMix = 'none';
                    }

                    if (ChartPropsManager.mixTimePartsToNumeric) {
                        if (timePart != null) {
                            at = 'i'; //"_tp";
                        }
                    }

                    if (isDate == null) {
                        isDate = canDate;
                    } else {
                        isDate = isDate && canDate;
                    }
                }

                dataTypes.push(at);
            }
        }

        let t = ChartPropsManager.combine_dataTypes(dataTypes);
        if (t != null) {
            yType = t;
        }

        if (yType != 'i') {
            timePartMix = null;
        }

        if (ChartPropsManager.mixTimePartsToNumeric) {
            if (timePartMix != null && timePartMix !== 'none' && yType === 'i') {
                //"_tp";
                yType = 'datetime';
            }
        }

        return { yType: yType, isDate: isDate, timePart: timePartMix };
    }

    public static get_yType_Multi(attrQueryMulti, glob: IGlob) {
        if (attrQueryMulti == null) {
            return { type: 's', isDate: false, timePart: 'none' };
        }

        let yType = 'i'; // 's';
        let isDate; //LL: real Date, i.e. that can be converted to date
        let timePartMix;
        let dataTypes = [];

        for (let k = 0; k < attrQueryMulti.attrQueries.length; k++) {
            let aq = attrQueryMulti.attrQueries[k];

            if (aq.parameters != null) {
                let _secondaryValueAxis_param = aq.parameters.secondaryValueAxis;
                if (
                    !(
                        _secondaryValueAxis_param == null ||
                        _secondaryValueAxis_param === '' ||
                        _secondaryValueAxis_param === 'Y'
                    )
                ) {
                    continue;
                }
            }

            let dd = aq.dataDescriptor;
            let yT = ChartPropsManager.get_yType(dd, aq.dataSourceID, glob); // return { yType: yType, isDate: isDate, timePart: timePartMix };

            if (isDate == null) {
                isDate = yT.isDate;
            } else {
                isDate = isDate && yT.isDate;
            }

            if (timePartMix == null) {
                timePartMix = yT.timePart;
            } else if (timePartMix !== yT.timePart) {
                timePartMix = 'none';
            }

            if (ChartPropsManager.mixTimePartsToNumeric) {
                if (yT.timePart != null) {
                    yT.yType = 'i'; //"_tp";
                }
            }

            dataTypes.push(yT.yType);
        }

        let t = ChartPropsManager.combine_dataTypes(dataTypes);
        if (t != null) {
            yType = t;
        }

        if (ChartPropsManager.mixTimePartsToNumeric) {
            if (timePartMix != null && timePartMix !== 'none' && yType === 'i') {
                //"_tp";
                yType = 'datetime';
            }
        }

        return { yType: yType, isDate: isDate, timePart: timePartMix };
    }

    public static get_valueAxis_DataType_Multi(attrQueryMulti, glob: IGlob) {
        let o = ChartPropsManager.get_yType_Multi(attrQueryMulti, glob);
        return o;
    }

    public static get_valueAxis_DataType_withTimePart(values, glob: IGlob) {
        if (values == null) {
            return {}; // or null
        }

        let o = ChartPropsManager.get_valueAxis_DataType_Multi(values['attrQueryMulti'], glob);
        let dType = o.yType;
        let timePart = o.timePart;

        if (ChartPropsManager.isDateTimeType(dType)) {
            if (o.timePart != null && o.timePart !== 'none') {
                dType = 'i';
            } else if (!o.isDate) {
                dType = 's';
            }
        }

        return { type: dType, timePart: timePart };
    }

    public static hasQueryStackedAxis(query) {
        let has = false;
        for (let i = 0; i < query.length; i++) {
            let value = query[i];
            if (value.axis === ChartPropsManager.x3_Val || value.axis === ChartPropsManager.y3_Val) {
                has = true;
                break;
            }
        }
        return has;
    }

    public static hasQuerySideBySideAxis(query) {
        let has = false;
        for (let i = 0; i < query.length; i++) {
            let value = query[i];
            if (value.axis === ChartPropsManager.x2_Val) {
                has = true;
                break;
            }
        }
        return has;
    }

    public static hasSecondaryGroupAggregation(query) {
        let need = false;
        for (let i = 0; i < query.length; i++) {
            let value = query[i];
            if (value.aggregateGroup === 'group') {
                if (
                    value.axis === ChartPropsManager.xC_Val ||
                    value.axis === ChartPropsManager.xL_Val ||
                    value.axis === ChartPropsManager.xP_Val ||
                    value.axis === ChartPropsManager.C2F_Val ||
                    value.axis === ChartPropsManager.T_Val ||
                    value.axis === ChartPropsManager.A_Val
                ) {
                    need = true;
                    break;
                }
            }
        }
        return need;
    }

    public static is_fullStackedOnAxis(theme: IValuesCollection, values, axisName?) {
        //LL: axis is Y here
        let fullStackedOnAxis = false;
        let _fullStacked = false;
        let resV = getValueFromTheme(theme, 'geometryMisc_fullStacked');

        if (resV != null) {
            _fullStacked = resV;
        }

        if (values == null) {
            return false;
        }

        let QM = values['attrQueryMulti'];

        if (_fullStacked === true && QM != null) {
            for (let k = 0; k < QM.attrQueries.length; k++) {
                let AQ = QM.attrQueries[k];

                if (AQ.parameters.used === false) {
                    continue;
                }

                let query = AQ.dataDescriptor;
                let hasStacked = ChartPropsManager.hasQueryStackedAxis(query);

                if (hasStacked) {
                    if (AQ.parameters != null) {
                        let _secondaryValueAxis_param = AQ.parameters.secondaryValueAxis;

                        if (axisName == null) {
                            if (
                                _secondaryValueAxis_param == null ||
                                _secondaryValueAxis_param === '' ||
                                _secondaryValueAxis_param === 'Y'
                            ) {
                                fullStackedOnAxis = true;
                                break;
                            }
                        } else {
                            if (_secondaryValueAxis_param === axisName) {
                                fullStackedOnAxis = true;
                                break;
                            }
                        }
                    }
                }
            }
        }

        return fullStackedOnAxis;
    }

    public static hasAxis_Bubble(values, axisName?) {
        if (values == null) {
            return false;
        }

        let attrQueryMulti = values['attrQueryMulti'];

        if (attrQueryMulti == null) {
            return false;
        }

        if (attrQueryMulti.attrQueries == null || attrQueryMulti.attrQueries.length === 0) {
            return false;
        }

        for (let k = 0; k < attrQueryMulti.attrQueries.length; k++) {
            let par = attrQueryMulti.attrQueries[k].parameters;
            if (par.used === false) {
                continue;
            }
            if (par.chartType === 'bubble') {
                let _secondaryValueAxis = par.secondaryValueAxis;
                if (typeof axisName === 'undefined') {
                    if (_secondaryValueAxis == null || _secondaryValueAxis === '' || _secondaryValueAxis === 'Y') {
                        return true;
                    }
                } else if (_secondaryValueAxis === axisName) {
                    return true;
                }
            }
        }
        return false;
    }

    public static get_valueAxis_AxisType_listCur_Full(values, glob: IGlob, toDisplay?) {
        let defaultValue = 'default';
        if (toDisplay === true) {
            defaultValue = 'automatic'; //LL: by Leo
        }

        if (values == null) {
            return [defaultValue];
        }

        let o = ChartPropsManager.get_valueAxis_DataType_Multi(values['attrQueryMulti'], glob);
        let yType = o.yType;

        switch (yType) {
            case 's':
            case 'b':
            case 'e':
                return [defaultValue, 'discrete'];
            case 'i':
            case 'r':
                return [defaultValue, 'discrete', 'continuous', 'logarithmic'];
            case 'datetime':
            case 'date':
            case 'time':
                let can = o.isDate;
                if (can) {
                    return [defaultValue, 'discrete', 'continuous'];
                } else {
                    //LL: see WI 56111"Charts: TimeParts (Week) on Argument Axis, continuous is prohibited":
                    //    Mail 23.11.15  "BUG Week can not be put on a Linear scale":
                    //    See: http://aviation1.pdc.dk/nextjet/#tabs/0/workspaces/2030
                    //    A datepart is always a number, that could be put on a linear scale

                    //LL: when 'continuous' is set, DevExpress error on console:
                    //    E2002 - Axis type and data type are incompatible. See:
                    //    http://js.devexpress.com/error/15_2/E2002
                    //LL:  because here 'continuous' is set for 'string' values. (They are strings by format)

                    //LL: my flag, Leo wants = false
                    if (ChartPropsManager.ApplyFormattedTimeParts) {
                        //LL: old:
                        return [defaultValue, 'discrete'];
                    } else {
                        //   <==  this
                        if (o.timePart != null) {
                            return [defaultValue, 'discrete', 'continuous'];
                        } else {
                            return [defaultValue, 'discrete'];
                        }
                    }
                }

            default:
                return [defaultValue, 'discrete'];
        }
    }

    public static getModifiedValuesAndDisplay_valueAxis_AxisType_Full(values, glob: IGlob) {
        let a = ChartPropsManager.get_valueAxis_AxisType_listCur_Full(values, glob);
        let d = ChartPropsManager.get_valueAxis_AxisType_listCur_Full(values, glob, true);

        return { values: a, display: d };
    }

    public static get_SecondaryValueAxis_Multi(attrQueryMulti: IAttrQueryMulti) {
        if (attrQueryMulti == null) {
            return null;
        }

        if (attrQueryMulti.attrQueries == null || attrQueryMulti.attrQueries.length === 0) {
            return null;
        }

        const result: string[] = [];

        for (let k = 0; k < attrQueryMulti.attrQueries.length; k++) {
            const par = attrQueryMulti.attrQueries[k].parameters;

            if (par.used === false || par.secondaryValueAxis == null) {
                continue;
            }

            result.push(par.secondaryValueAxis);
        }

        return result;
    }

    public static isUsed_SecondaryValueAxis(values, axisName: string) {
        if (values == null || values.attrQueryMulti == null) {
            return false;
        }

        const axes = ChartPropsManager.get_SecondaryValueAxis_Multi(values.attrQueryMulti);

        for (let k = 0; k < axes.length; k++) {
            if (axes[k] === axisName) {
                return true;
            }
        }
        return false;
    }

    public static isUsed_SecondaryValueAxis_Multi(attrQueryMulti: IAttrQueryMulti, axisName: string) {
        if (attrQueryMulti == null) {
            return false;
        }

        let axes = ChartPropsManager.get_SecondaryValueAxis_Multi(attrQueryMulti);

        for (let k = 0; k < axes.length; k++) {
            if (axes[k] === axisName) {
                return true;
            }
        }

        return false;
    }

    public static isAssignedSecondaryAxis(values, axisName) {
        let isAssigned = false;

        if (values == null) {
            return false;
        }

        let attrQueryMulti = values['attrQueryMulti'];
        if (attrQueryMulti == null) {
            return isAssigned;
        }

        for (let k = 0; k < attrQueryMulti.attrQueries.length; k++) {
            let aq = attrQueryMulti.attrQueries[k];
            if (aq.parameters != null) {
                if (aq.parameters.secondaryValueAxis === axisName) {
                    isAssigned = true;
                    break;
                }
            }
        }

        return isAssigned;
    }

    public static get_yType_Multi_SecondaryAxis(attrQueryMulti: IAttrQueryMulti, axisName: string, glob: IGlob) {
        if (attrQueryMulti == null) {
            return { type: 's', isDate: false, timePart: 'none' };
        }

        let yType = 's';
        let isDate; //LL: real Date, i.e. that can be converted to date
        let timePartMix;
        let dataTypes = [];

        for (let k = 0; k < attrQueryMulti.attrQueries.length; k++) {
            let aq = attrQueryMulti.attrQueries[k];

            if (aq.parameters != null) {
                if (aq.parameters.secondaryValueAxis !== axisName) {
                    continue;
                }
            }
            let dd = aq.dataDescriptor;
            let yT = ChartPropsManager.get_yType(dd, aq.dataSourceID, glob); // return { yType: yType, isDate: isDate, timePart: timePartMix };

            if (isDate == null) {
                isDate = yT.isDate;
            } else {
                isDate = isDate && yT.isDate;
            }

            if (timePartMix == null) {
                timePartMix = yT.timePart;
            } else if (timePartMix !== yT.timePart) {
                timePartMix = 'none';
            }

            if (ChartPropsManager.mixTimePartsToNumeric) {
                if (yT.timePart != null) {
                    yT.yType = 'i'; //"_tp";
                }
            }

            dataTypes.push(yT.yType);
        }

        let t = ChartPropsManager.combine_dataTypes(dataTypes);
        if (t != null) {
            yType = t;
        }

        if (ChartPropsManager.mixTimePartsToNumeric) {
            if (timePartMix != null && timePartMix !== 'none' && yType === 'i') {
                //"_tp";
                yType = 'datetime';
            }
        }

        return { yType: yType, isDate: isDate, timePart: timePartMix };
    }

    public static get_secondaryAxis_DataType_withTimePart(values, axisName: string, theme: IValuesCollection, glob: IGlob) {
        if (values == null) {
            return null;
        }

        if (!ChartPropsManager.isMultiValueAxis(values, theme)) {
            return null;
        }

        // { yType: yType, isDate: isDate, timePart: timePartMix };
        let o = ChartPropsManager.get_yType_Multi_SecondaryAxis(values['attrQueryMulti'], axisName, glob);
        let dType = o.yType;
        let timePart = o.timePart;

        if (ChartPropsManager.isDateTimeType(dType)) {
            if (o.timePart != null && o.timePart !== 'none') {
                dType = 'i';
            } else if (!o.isDate) {
                dType = 's';
            }
        }
        return { type: dType, timePart: timePart };
    }

    public static get_secondaryAxis_AxisType_listCur_Full(axisName, values, glob: IGlob, toDisplay?) {
        let defaultValue = 'default';
        if (toDisplay === true) {
            defaultValue = 'automatic'; //LL: by Leo
        }

        if (values == null) {
            return [defaultValue, 'discrete'];
        }

        // { yType: yType, isDate: isDate, timePart: timePartMix };
        let o = ChartPropsManager.get_yType_Multi_SecondaryAxis(values['attrQueryMulti'], axisName, glob);
        let yType: string = o.yType;

        switch (yType) {
            case 's':
            case 'b':
            case 'e':
                return [defaultValue, 'discrete'];
            case 'i':
            case 'r':
                return [defaultValue, 'discrete', 'continuous', 'logarithmic'];
            case 'datetime':
            case 'date':
            case 'time':
                let can = o.isDate;
                if (can) {
                    return [defaultValue, 'discrete', 'continuous'];
                } else {
                    //LL: my flag, Leo wants = false
                    if (ChartPropsManager.ApplyFormattedTimeParts) {
                        //LL: old:
                        return [defaultValue, 'discrete'];
                    } else {
                        //   <==  this
                        if (o.timePart != null) {
                            return [defaultValue, 'discrete', 'continuous'];
                        } else {
                            return [defaultValue, 'discrete'];
                        }
                    }
                }
            default:
                return [defaultValue, 'discrete'];
        }
    }

    public static getModifiedValuesAndDisplay_secondaryAxis_AxisType_Full(values, glob: IGlob, axisName: string) {
        let a = ChartPropsManager.get_secondaryAxis_AxisType_listCur_Full(axisName, values, glob);
        let d = ChartPropsManager.get_secondaryAxis_AxisType_listCur_Full(axisName, values, glob, true);

        return { values: a, display: d };
    }

    // - AsPercent

    public static prohibitAsPercent_byDataType(dataType) {
        let prohibit = !(dataType === 'i' || dataType === 'r');
        return prohibit;
    }

    public static prohibitAsPercent_byAxisType_byDataType(axisType: string, dataType: string) {
        //LL: use for Y axis.  'default' is 'continuous'
        let prohibit = !(dataType === 'i' || dataType === 'r');
        if (!prohibit) {
            prohibit = axisType === 'discrete';
        }
        return prohibit;
    }

    public static get_valueAxis_DataType(values, glob: IGlob) {
        if (values == null) {
            return '';
        }

        let dType = 's';
        // { yType: yType, isDate: isDate, timePart: timePartMix };
        let o = ChartPropsManager.get_valueAxis_DataType_Multi(values['attrQueryMulti'], glob);

        dType = o.yType;
        if (ChartPropsManager.isDateTimeType(dType) && o.isDate !== true) {
            dType = 's';
        }

        return dType;
    }

    //LL: used in Strips, ConstLines  and similar ..._inThemes
    public static prohibitAsPercent_byAttrQuery_Y_multi(values, glob: IGlob) {
        let yType = ChartPropsManager.get_valueAxis_DataType(values, glob);

        return ChartPropsManager.prohibitAsPercent_byDataType(yType);
    }

    //LL: used in Strips, ConstLines  and similar ..._inThemes
    public static prohibitAsPercent_byAttrQuery_X_multi(values, glob: IGlob) {
        let typeExt: any = ChartPropsManager.get_argumentAxis_DataType_extended(values, glob);
        let argType = typeExt.type;

        return ChartPropsManager.prohibitAsPercent_byDataType(argType); // only i and r
    }

    public static prohibitAsPercent_byAxisType_Y(axisType) {
        return axisType === 'discrete';
    }

    //LL: used in Strips, ConstLines  and similar ..._inThemes
    public static prohibitAsPercent_byAxisType_byAxisObjY(values, theme: IValuesCollection) {
        let axisObj = getValueFromTheme(theme, 'axis_ChartAxisField_Arr');

        if (axisObj == null) {
            return true;
        }

        return ChartPropsManager.prohibitAsPercent_byAxisType_Y(axisObj.type);
    }

    public static isContinuous(axisType) {
        return axisType === 'continuous' || axisType === 'logarithmic';
    }

    public static prohibitAsPercent_byAxisType(axisType) {
        return !ChartPropsManager.isContinuous(axisType);
    }

    //LL: used in Strips, ConstLines  and similar ..._inThemes
    public static prohibitAsPercent_byAxisType_byAxisObjX(values, theme: IValuesCollection) {
        let axisObj = getValueFromTheme(theme, 'axis_ChartAxisField_X');
        if (axisObj == null) {
            return true;
        }
        return ChartPropsManager.prohibitAsPercent_byAxisType(axisObj.type);
    }

    //LL: used in Strips, ConstLines  and similar ..._inThemes
    public static prohibitAsPercent_SecondaryValueAxis(values, axisName: string, theme: IValuesCollection, glob: IGlob) {
        let o = ChartPropsManager.get_yType_Multi_SecondaryAxis(values['attrQueryMulti'], axisName, glob); // { yType: yType, isDate: isDate, timePart: timePartMix };

        let aaType: string = o.yType;

        let prohibitAsPercent = ChartPropsManager.prohibitAsPercent_byDataType(aaType);

        if (prohibitAsPercent !== true) {
            let axisType;
            let ChartAxisArrayField = getValueFromTheme(theme, 'axis_ChartAxisField_Arr');
            if (ChartAxisArrayField != null) {
                if (ChartAxisArrayField[axisName] != null) {
                    axisType = ChartAxisArrayField[axisName].type;
                }
            }
            prohibitAsPercent = ChartPropsManager.prohibitAsPercent_byAxisType_byDataType(axisType, aaType);
        }

        return prohibitAsPercent;
    }

    //LL: from main.ts ========  Labels Format =====================

    public static FormatFrontArray_Numeric = [
        'currency',
        'fixedPoint',
        'percent',
        'decimal',
        'exponential',
        'largeNumber',
        'thousands',
        'millions',
        'billions',
        'trillions'
    ];

    //LL: for DevExpr 16.1:
    //  https://js.devexpress.com/Documentation/16_1/Guide/Data_Visualization/Common/Data_Formatting/#Data_Formatting
    //  added formats:
    //   'longDateLongTime' - "Thursday, January 01, 1970, 12:00:00 AM"
    //   'shortDateShortTime' - "1/25/1970, 12:00 AM"
    //   'dayOfWeek' - "Thursday"
    //   'hour' - "12"
    //   'minute' - "00"
    public static FormatFrontArray_DateTime = [
        'longDate',
        'longTime',
        'longDateLongTime', //LL: for DevExpr 16.1
        'monthAndDay',
        'monthAndYear',
        'quarterAndYear',
        'shortDate',
        'shortTime',
        'shortDateShortTime', //LL: for DevExpr 16.1
        'day',
        'month',
        'quarter',
        'year',
        'dayOfWeek', //LL: for DevExpr 16.1
        'hour', //LL: for DevExpr 16.1
        'minute', //LL: for DevExpr 16.1
        'millisecond',
        'longDateTime',
        'shortDateTime',
        'Universal',
        'custom'
    ];

    //LL:  part of FormatFrontArray_DateTime:
    public static FormatFrontArray_Date = [
        'longDate',
        'shortDate',
        'monthAndDay',
        'monthAndYear',
        'quarterAndYear',
        'year',
        'month',
        'quarter',
        'day',
        'custom'
    ];

    //LL:  part of FormatFrontArray_DateTime:
    public static FormatFrontArray_Time = [
        'longTime',
        'shortTime',
        'hour', //LL: for DevExpr 16.1
        'minute', //LL: for DevExpr 16.1
        'millisecond',
        'custom'
    ];

    public static getFormatFrontArray_Numeric() {
        let arr = ['default'];
        return arr.concat(ChartPropsManager.FormatFrontArray_Numeric);
    }

    public static getFormatFrontArray_Time() {
        let arr = ['default'];
        return arr.concat(ChartPropsManager.FormatFrontArray_Time);
    }

    public static getFormatFrontArray_Date() {
        let arr = ['default'];
        return arr.concat(ChartPropsManager.FormatFrontArray_Date);
    }

    public static getFormatFrontArray_DateTime() {
        let arr = ['default'];
        return arr.concat(ChartPropsManager.FormatFrontArray_DateTime);
    }

    public static getFormatFrontArray_TimePart(timePart) {
        let arr = ['default'];
        //LL: see in ...dxChart_Parametrized: function convertDate(value, timePart, format?)
        //LL:  using formatting from Utilities.ts, so rename
        //LL: these are codes, convert them to names when using
        let a = [];

        switch (timePart) {
            case 'year':
                a = ['longYear', 'shortYear'];
                break;
            case 'yearFiscal':
                a = [
                    'longYear',
                    'shortYear',
                    TIME_PART_FORMATS.LONG_FISCAL_YEAR,
                    TIME_PART_FORMATS.SHORT_FISCAL_YEAR,
                    TIME_PART_FORMATS.LONG_FISCAL_YEAR_START_END,
                    TIME_PART_FORMATS.SHORT_FISCAL_YEAR_START_END
                ];
                break;
            case 'halfyear':
                a = ['longHalfYear', 'shortHalfYear'];
                break;
            case 'halfYearFiscal':
                a = ['longHalfYear', 'shortHalfYear', 'longHalfYearFiscal', 'shortHalfYearFiscal'];
                break;
            case 'quarter':
                a = ['Q_N', 'latin_N', 'Qlatin_N'];
                break;
            case 'quarterFiscal':
                a = ['Q_N', 'latin_N', 'Qlatin_N', 'Q_Fiscal', 'latin_Fiscal', 'Qlatin_Fiscal'];
                break;
            case 'month':
                a = ['longMonth', 'shortMonth', 'monthNumber'];
                break;
            case 'weekday':
                a = ['longweekDay', 'shortweekDay', 'minWeekDay', 'weekDayNumber'];
                break;
            // case 'hour':
            //     break;
        }

        return arr.concat(a);
    }

    public static getFormatFrontArray_TimeIntervals_Int() {
        const arr = [];

        _.each(FORMATS[ATTRIBUTE_TYPES.INTEGER], (item) => {
            if (item.timeInterval === true) {
                arr.push(item.value);
            }
        });
        return arr;
    }

    public static getFormatFrontArray_TimeIntervals_Real() {
        const arr = [];

        _.each(FORMATS[ATTRIBUTE_TYPES.REAL], (item) => {
            if (item.timeInterval === true) {
                arr.push(item.value);
            }
        });
        return arr;
    }

    //LL: 03.04.25: and func is actually getFormatFrontArray_TimePart above
    public static integer_TimePartFormats() {
        //if (getFormatFrontArray_TimePart_Func == null) {
        //const getFormatFrontArray_TimePart_Func = ChartPropsManager.getFormatFrontArray_TimePart;
        //}

        let result = ['default'];

        //if (typeof getFormatFrontArray_TimePart_Func === 'function') {
        //LL: all TimeParts here
        let tps = ['year', 'yearFiscal', 'halfyear', 'halfYearFiscal', 'quarter', 'quarterFiscal', 'month', 'weekday'];

        tps.forEach((tp) => {
            let arr = ChartPropsManager.getFormatFrontArray_TimePart(tp); //getFormatFrontArray_TimePart_Func(tp);

            if (arr != null) {
                if (arr.length > 0 && arr[0] === 'default') {
                    arr.shift();
                }

                if (arr.length > 0) {
                    result = result.concat(arr);
                }
            }
        });
        //}
        //LL: formats may be not unique, for example, year and yearFiscal have same names LongFormat and ShortFormat
        result = _.uniq(result);
        result.push('custom');

        return result;
    }

    public static canAxisLabelPrecision_byLabelFormat(labelFormat) {
        //LL for fullStacked: add 'default'
        let can =
            labelFormat == null ||
            labelFormat === 'default' ||
            labelFormat === 'fixedPoint' ||
            labelFormat === 'exponential' ||
            labelFormat === 'currency' ||
            labelFormat === 'percent';
        return can;
    }
}
